export default "__VITE_ASSET__49cb8e57__"